( function () {
	'use strict';

	var focusableSelector = [
		'a[href]',
		'button:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'textarea:not([disabled])',
		'[tabindex]:not([tabindex="-1"])',
	].join( ',' );

	function initMegaNav( root ) {
		var toggle = getOne( '[data-ornl-mega-nav-toggle]' );
		var overlay = getOne( '[data-ornl-mega-nav-overlay]' );
		var dialog = getOne( '[data-ornl-mega-nav-dialog]' );
		var detail = getOne( '[data-ornl-mega-nav-detail]' );
		var detailTitle = getOne( '[data-ornl-mega-nav-detail-title]' );
		var generalButton = getOne( '[data-ornl-mega-nav-general]' );
		var generalPanel = getOne( '[data-ornl-mega-nav-general-panel]' );
		var back = getOne( '[data-ornl-mega-nav-back]' );
		var close = getOne( '[data-ornl-mega-nav-close]' );
		var primaryButtons = getAll( '[data-ornl-mega-nav-primary]' );
		var secondaryButtons = getAll( '[data-ornl-mega-nav-secondary]' );
		var secondaryGroups = getAll( '[data-ornl-mega-nav-secondary-group]' );
		var panels = getAll( '[data-ornl-mega-nav-panel]' );
		var lastFocused;
		var header = root.closest(
			'.prototype-brand-header--has-mega-nav, .ornl-brand-header--inner--has-mega-nav'
		);
		var isAdminPreview = !! root.closest( '.ornl-mega-nav-admin__preview' );

		if ( ! toggle || ! overlay || ! dialog ) {
			return;
		}

		function getOne( selector, context ) {
			return ( context || root ).querySelector( selector );
		}

		function getAll( selector, context ) {
			return Array.prototype.slice.call(
				( context || root ).querySelectorAll( selector )
			);
		}

		function setActiveItem( items, activeItem, attribute ) {
			items.forEach( function ( item ) {
				var isActive = item === activeItem;

				item.classList.toggle( 'is-active', isActive );

				if ( attribute ) {
					item.setAttribute( attribute, isActive ? 'true' : 'false' );
				}
			} );
		}

		function hideExcept( items, visibleItem ) {
			items.forEach( function ( item ) {
				item.hidden = item !== visibleItem;
			} );
		}

		function isActivationKey( event ) {
			return 'Enter' === event.key || ' ' === event.key;
		}

		function showDetail( callback ) {
			if ( detail ) {
				detail.classList.add( 'is-active' );
			}

			dialog.classList.add( 'is-detail-active' );

			if ( 'function' === typeof callback ) {
				callback();
			}
		}

		function updateOverlayOffset() {
			var headerBounds;

			if ( isAdminPreview || ! header ) {
				overlay.style.removeProperty( '--ornl-mega-nav-header-offset' );
				overlay.style.removeProperty( '--ornl-mega-nav-mobile-offset' );
				return;
			}

			headerBounds = header.getBoundingClientRect();
			overlay.style.setProperty(
				'--ornl-mega-nav-header-offset',
				Math.max( 0, headerBounds.bottom ) + 'px'
			);
			overlay.style.setProperty(
				'--ornl-mega-nav-mobile-offset',
				Math.max( 0, headerBounds.bottom ) + 'px'
			);
		}

		function openNav() {
			lastFocused = document.activeElement;
			updateOverlayOffset();
			overlay.hidden = false;
			resetToGeneral();
			toggle.setAttribute( 'aria-expanded', 'true' );
			document.body.classList.add( 'ornl-mega-nav-is-open' );
			document.addEventListener( 'keydown', handleDocumentKeydown );
			window.addEventListener( 'resize', updateOverlayOffset );
			// focusFirstPrimary();
		}

		function closeNav() {
			overlay.hidden = true;
			toggle.setAttribute( 'aria-expanded', 'false' );
			hideMobileDetail();
			document.body.classList.remove( 'ornl-mega-nav-is-open' );
			document.removeEventListener( 'keydown', handleDocumentKeydown );
			window.removeEventListener( 'resize', updateOverlayOffset );

			if ( lastFocused && 'function' === typeof lastFocused.focus ) {
				lastFocused.focus();
			} else {
				toggle.focus();
			}
		}

		function getPrimaryLabel( button ) {
			var label = button.querySelector( 'span' );

			return label ? label.textContent.trim() : button.textContent.trim();
		}

		function getGeneralLabel() {
			return generalButton ? getPrimaryLabel( generalButton ) : 'Explore';
		}

		function resetToGeneral() {
			setActiveItem( primaryButtons, null, 'aria-expanded' );
			setActiveItem( secondaryButtons, null, 'aria-selected' );
			hideExcept( secondaryGroups, null );
			hideExcept( panels, generalPanel );

			if ( detailTitle ) {
				detailTitle.textContent = getGeneralLabel();
			}

			dialog.classList.add( 'is-general-active' );
			hideMobileDetail();
		}

		function showMobileDetail( button, focusSecondary ) {
			var firstSecondary;

			if ( detailTitle ) {
				detailTitle.textContent = getPrimaryLabel( button );
			}

			showDetail( function () {
				if ( ! focusSecondary ) {
					return;
				}

				firstSecondary = getOne(
					'[data-ornl-mega-nav-secondary-group]:not([hidden]) [data-ornl-mega-nav-secondary]'
				);

				if ( firstSecondary ) {
					firstSecondary.focus();
				}
			} );
		}

		function showGeneralDetail() {
			resetToGeneral();

			showDetail( function () {
				if ( back ) {
					back.focus();
				}
			} );
		}

		function hideMobileDetail() {
			if ( detail ) {
				detail.classList.remove( 'is-active' );
			}

			dialog.classList.remove( 'is-detail-active' );
		}

		function toggleNav() {
			if ( overlay.hidden ) {
				openNav();
			} else {
				closeNav();
			}
		}

		/*  TODO: 0.6.0
			This should focus the first item that has content, not the first item in the list.
			
			focusFirstPrimary()` is an accessibility/focus-management helper. It decides where keyboard focus should go when the mega nav opens.

			In [ornl-mega-nav.js](/Users/9w0/Sites/localhost/wwwplatform/app/public/wp-content/plugins/ornl-mega-nav/src/Components/MegaNav/ornl-mega-nav.js:200), it checks targets in this order:

			1. If the `generalButton` exists and is visible, focus that.
			2. Otherwise, if a primary nav button already has `.is-active`, focus that.
			3. Otherwise, focus the first primary nav button.
			4. Otherwise, as a fallback, focus the first primary link with an `href`.

			So in plain terms: **when the menu opens, put focus on the most appropriate top-level nav item so keyboard users can start navigating inside the menu immediately.**

			One small nuance: the name is a little misleading, because it does **not always** focus the first primary item. It prefers the visible “general” button first. Since `openNav()` calls `resetToGeneral()` right before this, the most common path is probably: focus the general button if visible, otherwise focus the first primary button.	
		*/
		function focusFirstPrimary() {
			var activePrimary = root.querySelector(
				'[data-ornl-mega-nav-primary].is-active'
			);

			if ( generalButton && null !== generalButton.offsetParent ) {
				generalButton.focus();
				return;
			}

			if ( activePrimary ) {
				activePrimary.focus();
				return;
			}

			if ( primaryButtons.length ) {
				primaryButtons[ 0 ].focus();
				return;
			}

			activePrimary = getOne( '.ornl-mega-nav__primary-link[href]' );

			if ( activePrimary ) {
				activePrimary.focus();
			}
		}

		function handleDocumentKeydown( event ) {
			if ( 'Escape' === event.key ) {
				event.preventDefault();
				closeNav();
				return;
			}

			if ( 'Tab' === event.key ) {
				trapFocus( event );
			}
		}

		function trapFocus( event ) {
			var focusScope = header || dialog;
			var focusable = getAll( focusableSelector, focusScope ).filter(
				function ( element ) {
					var styles = window.getComputedStyle( element );

					return (
						null !== element.offsetParent &&
						! element.closest( '[hidden]' ) &&
						'hidden' !== styles.visibility
					);
				}
			);
			var first;
			var last;

			if ( ! focusable.length ) {
				return;
			}

			first = focusable[ 0 ];
			last = focusable[ focusable.length - 1 ];

			if ( event.shiftKey && document.activeElement === first ) {
				event.preventDefault();
				last.focus();
			} else if ( ! event.shiftKey && document.activeElement === last ) {
				event.preventDefault();
				first.focus();
			}
		}

		function activatePrimary( button, focusSecondary ) {
			var primaryId = button.getAttribute( 'data-primary-id' );
			var group = getOne(
				'[data-ornl-mega-nav-secondary-group="' + primaryId + '"]'
			);
			var firstSecondary;

			dialog.classList.remove( 'is-general-active' );
			setActiveItem( primaryButtons, button, 'aria-expanded' );
			hideExcept( secondaryGroups, group );

			firstSecondary = group
				? getOne( '[data-ornl-mega-nav-secondary]', group )
				: null;

			if ( firstSecondary ) {
				activateSecondary( firstSecondary );

				if ( focusSecondary ) {
					firstSecondary.focus();
				}
			} else {
				hideExcept( panels, null );
			}
		}

		function activateSecondary( button ) {
			var panelId = button.getAttribute( 'data-panel-id' );

			dialog.classList.remove( 'is-general-active' );
			setActiveItem( secondaryButtons, button, 'aria-selected' );

			panels.forEach( function ( panel ) {
				panel.hidden =
					panel.getAttribute( 'data-ornl-mega-nav-panel' ) !== panelId;
			} );
		}

		function moveFocus( buttons, currentButton, direction ) {
			var currentIndex = buttons.indexOf( currentButton );
			var nextIndex;

			if ( -1 === currentIndex || ! buttons.length ) {
				return;
			}

			nextIndex =
				( currentIndex + direction + buttons.length ) % buttons.length;

			buttons[ nextIndex ].focus();
		}

		toggle.addEventListener( 'click', toggleNav );

		if ( close ) {
			close.addEventListener( 'click', closeNav );
		}

		if ( back ) {
			back.addEventListener( 'click', function () {
				var activePrimary;

				hideMobileDetail();

				activePrimary = root.querySelector(
					'[data-ornl-mega-nav-primary].is-active'
				);

				if ( activePrimary ) {
					activePrimary.focus();
				}
			} );
		}

		if ( generalButton ) {
			generalButton.addEventListener( 'click', function () {
				showGeneralDetail();
			} );

			generalButton.addEventListener( 'keydown', function ( event ) {
				if ( isActivationKey( event ) ) {
					event.preventDefault();
					showGeneralDetail();
				}
			} );
		}

		overlay.addEventListener( 'pointerdown', function ( event ) {
			if ( event.target === overlay ) {
				closeNav();
			}
		} );

		primaryButtons.forEach( function ( button ) {
			button.addEventListener( 'click', function () {
				activatePrimary( button, false );
				showMobileDetail( button, false );
			} );

			button.addEventListener( 'keydown', function ( event ) {
				if ( 'ArrowDown' === event.key || 'ArrowRight' === event.key ) {
					event.preventDefault();
					moveFocus( primaryButtons, button, 1 );
				} else if (
					'ArrowUp' === event.key ||
					'ArrowLeft' === event.key
				) {
					event.preventDefault();
					moveFocus( primaryButtons, button, -1 );
				} else if ( isActivationKey( event ) ) {
					event.preventDefault();
					activatePrimary( button, true );
					showMobileDetail( button, true );
				}
			} );
		} );

		secondaryButtons.forEach( function ( button ) {
			button.addEventListener( 'click', function () {
				activateSecondary( button );
			} );

			button.addEventListener( 'keydown', function ( event ) {
				var visibleButtons = getAll(
					'[data-ornl-mega-nav-secondary-group]:not([hidden]) [data-ornl-mega-nav-secondary]'
				);

				if ( 'ArrowDown' === event.key || 'ArrowRight' === event.key ) {
					event.preventDefault();
					moveFocus( visibleButtons, button, 1 );
				} else if (
					'ArrowUp' === event.key ||
					'ArrowLeft' === event.key
				) {
					event.preventDefault();
					moveFocus( visibleButtons, button, -1 );
				} else if ( isActivationKey( event ) ) {
					event.preventDefault();
					activateSecondary( button );
				}
			} );
		} );
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		Array.prototype.slice
			.call( document.querySelectorAll( '[data-ornl-mega-nav]' ) )
			.forEach( initMegaNav );
	} );
}() );
